/**
 * The whole instance list
 * wtshuang@cs.uw.edu
 * 2018/01/15
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { Grid } from 'semantic-ui-react';

import { store } from '../stores/Store';
import { utils } from '../stores/Utils';
import { Question } from '../stores/Question';

import { InstancePanel } from './InstancePanel';


@observer
export class InstanceList extends React.Component<{}, {}> {
    private viewType: string;
    constructor(props: any, context: any) {
        super(props, context);
        this.viewType = 'qlist';
    }

    /**
     * Rendering function called whenever new logs are generated.
     */
    public render(): JSX.Element {
        return <Grid key={this.viewType}>
            {store.questions.map((q: Question) => {
                const curClass = utils.genClass(this.viewType, 'qpanel', q.qid);
                return <Grid.Row key={curClass.key}><InstancePanel question={q} /></Grid.Row>
            }) }
        </Grid>;
     }
}    


// WEBPACK FOOTER //
// ./src/components/InstanceList.tsx